import { FileSignature, UserCheck, ShieldCheck, ClipboardCheck, Quote } from "lucide-react";

const POINTS = [
  {
    icon: UserCheck,
    title: "1. Process agents",
    body: "A person or company in each state who can legally receive court papers (legal 'service of process') on your behalf. FMCSA requires you to name one in every state you operate.",
  },
  {
    icon: FileSignature,
    title: "2. The BOC-3 filing",
    body: "One federal form that lists your process agents for all states. Only a registered process-agent company can file it — you can't file it yourself. Usually a small one-time fee.",
  },
  {
    icon: ShieldCheck,
    title: "3. Commercial auto liability",
    body: "Insurance that pays for injuries and damage you cause in a crash. FMCSA requires a minimum of $750,000 for general freight (more for hazmat). This is separate from cargo or physical-damage coverage.",
  },
  {
    icon: ClipboardCheck,
    title: "4. Proof filed + verify on L&I",
    body: "Your insurer files proof of coverage directly with FMCSA, and your BOC-3 must be on file too. Your MC authority will NOT activate until BOTH show on FMCSA's Licensing & Insurance (L&I) system — check it yourself.",
  },
];

// Plain-English explainer for BOC-3, process agents & commercial insurance (guide Step/Mission 4).
export default function Boc3InsuranceExplainer() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 sm:p-8" data-testid="boc3-insurance-explainer">
      <div className="flex items-center gap-2 mb-3">
        <FileSignature className="w-4 h-4 text-brand" />
        <span className="text-xs tracking-[0.2em] uppercase font-bold text-slate-500">Plain-English explainer</span>
      </div>
      <h3 className="font-heading text-2xl font-black tracking-tight text-slate-900">BOC-3, process agents &amp; insurance</h3>
      <p className="mt-3 text-slate-700 leading-relaxed">
        Two things must be on file with FMCSA before your authority turns on: a <strong>BOC-3</strong> (process agents in
        every state) and proof of <strong>commercial insurance</strong>. Here are the four pieces that make it happen.
      </p>

      <div className="mt-5 grid sm:grid-cols-2 gap-4">
        {POINTS.map((p) => {
          const Icon = p.icon;
          return (
            <div
              key={p.title}
              data-testid={`boc3-point-${p.title.charAt(0)}`}
              className="rounded-xl bg-white border border-slate-200 p-5"
            >
              <div className="flex items-center gap-2 mb-2">
                <Icon className="w-4 h-4 text-brand" />
                <span className="text-sm font-bold text-slate-900">{p.title}</span>
              </div>
              <p className="text-sm text-slate-700 leading-relaxed">{p.body}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-5 rounded-xl bg-brand/5 border border-brand/20 p-5">
        <div className="flex items-center gap-2 mb-1.5">
          <div className="w-7 h-7 rounded-full bg-brand flex items-center justify-center shrink-0">
            <Quote className="w-3.5 h-3.5 text-white" />
          </div>
          <span className="text-xs uppercase tracking-[0.15em] font-bold text-brand">Mentor tip</span>
        </div>
        <p className="text-sm text-slate-800 leading-relaxed">
          Get insurance quotes early — for a brand-new authority it's often the biggest startup cost. Line up the BOC-3
          and insurance filing during your 21-day protest window so your authority activates the day it's eligible. This
          isn't legal or insurance advice; work with a licensed agent.
        </p>
      </div>
    </div>
  );
}
